import React from 'react';
import './PageFooter.scss';
import {
  FacebookShareButton,
  FacebookIcon,
  LineShareButton,
  LineIcon,
} from 'react-share';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const PageFooter = () => {
  return (
    <div className="page-footer">
      <h3 className="share">歡迎分享</h3>
      <div className="share-icons">
        <FacebookShareButton url={'https://taiwanlibrarysearch.herokuapp.com/'}>
          <FacebookIcon borderRadius={45} size={45} />
        </FacebookShareButton>
        <LineShareButton url={'https://taiwanlibrarysearch.herokuapp.com/'}>
          <LineIcon borderRadius={45} size={45} />
        </LineShareButton>
      </div>
      <div>
        <input
          className="link-input"
          value="https://taiwanlibrarysearch.herokuapp.com/"
        />
        <CopyToClipboard text="https://taiwanlibrarysearch.herokuapp.com/">
          <button className="link-copy">
            <i className="copy icon" />
            複製連結
          </button>
        </CopyToClipboard>
      </div>
    </div>
  );
};

export default PageFooter;
